import { buildBavautoEtkUrl, isBmwVinForEtk } from "@/utils/bavautoEtk.js";

export default function VehicleCard({ t, vehicle }) {
  if (!vehicle) return null;

  const fromNhtsa =
    typeof vehicle.model === "string" && vehicle.model.includes("NHTSA vPIC");

  const dash = t.fieldEmptyValue ?? "—";

  const val = (x) => {
    const s = x === undefined || x === null ? "" : String(x).trim();
    return s === "" ? dash : s;
  };

  const mainRows = [
    [t.fieldVin, vehicle.vin_last7],
    ...(vehicle.vin_full && String(vehicle.vin_full).trim().length === 17
      ? [[t.fieldVinFull, vehicle.vin_full]]
      : []),
    [t.fieldBrand, vehicle.brand],
    [
      t.fieldManufacturer,
      vehicle.manufacturer ??
        vehicle.details?.["Producător"] ??
        vehicle.details?.["Manufacturer"] ??
        "",
    ],
    [t.fieldModel, vehicle.model],
    [t.fieldChassis, vehicle.chassis],
    [t.fieldEngine, vehicle.engine],
    [t.fieldProd, vehicle.production_date],
  ];

  const detailEntries = Object.entries(vehicle.details || {}).sort(([a], [b]) =>
    a.localeCompare(b, undefined, { sensitivity: "base" }),
  );

  const catalogIsBmwRealoem =
    typeof vehicle.source_url === "string" && /realoem\.com\/bmw/i.test(vehicle.source_url);

  const bmwCatalog = isBmwVinForEtk(vehicle);

  const vinLast7Clean = String(vehicle.vin_last7 || "")
    .replace(/[^A-Za-z0-9]/g, "")
    .toUpperCase()
    .slice(-7);
  const realoemBmwHref =
    !bmwCatalog
      ? ""
      : catalogIsBmwRealoem && vehicle.source_url
        ? vehicle.source_url
        : /^[A-Z0-9]{7}$/.test(vinLast7Clean)
          ? `https://www.realoem.com/bmw/enUS/select?vin=${encodeURIComponent(vinLast7Clean)}`
          : "https://www.realoem.com/bmw/enUS/";

  return (
    <section className="rounded-xl border border-[#e2e6ec] bg-white p-6 shadow-sm">
      <h2 className="text-lg font-bold text-[#0b1220] mb-4">{t.vehicleHeading}</h2>
      <dl className="grid gap-3 sm:grid-cols-2">
        {mainRows.map(([label, raw]) => (
          <div key={label} className="border-b border-[#f0f2f6] pb-2">
            <dt className="text-[11px] font-mono uppercase tracking-[0.16em] text-slate-500">
              {label}
            </dt>
            <dd className="text-sm text-[#0b1220] mt-1 break-words">{val(raw)}</dd>
          </div>
        ))}
      </dl>

      {detailEntries.length > 0 ? (
        <div className="mt-8">
          <h3 className="text-xs font-mono uppercase tracking-[0.18em] text-slate-500 mb-3">
            {t.vehicleDetailsSectionTitle}
          </h3>
          <div className="max-h-[28rem] overflow-y-auto rounded-lg border border-[#eef0f4] bg-[#fafbfc]">
            <dl className="grid gap-2 sm:grid-cols-2 p-4">
              {detailEntries.map(([label, value]) => (
                <div key={label} className="border-b border-[#e8ecf2] pb-2 sm:col-span-1">
                  <dt className="text-[10px] font-mono uppercase tracking-[0.12em] text-slate-500 leading-snug">
                    {label}
                  </dt>
                  <dd className="text-xs text-[#0b1220] mt-1 break-words whitespace-pre-wrap">{value}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      ) : null}

      {vehicle.source_url && (fromNhtsa || bmwCatalog) ? (
        <div className="mt-6 space-y-2">
          {fromNhtsa ? (
            <>
              <p className="text-sm">
                <span className="text-slate-600">{t.vehicleDecodeSourceLabel}: </span>
                <span className="text-[#0b1220] font-medium">{t.vehicleNhtsaName}</span>
                {" · "}
                <a
                  href="https://vpic.nhtsa.dot.gov/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#0b378c] underline break-all"
                >
                  vpic.nhtsa.dot.gov
                </a>
              </p>
              {realoemBmwHref ? (
                <p className="text-sm">
                  <a
                    href={realoemBmwHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#0b378c] underline break-all font-medium"
                  >
                    {t.partsCatalogLinkRealoem}
                  </a>
                </p>
              ) : null}
              <p className="text-xs text-slate-600 leading-relaxed">{t.vehicleNhtsaNote}</p>
            </>
          ) : bmwCatalog ? (
            <p className="text-sm">
              <span className="text-slate-600">{t.fieldSource}: </span>
              <a
                href={vehicle.source_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#0b378c] underline break-all"
              >
                {t.partsCatalogLinkRealoem}
              </a>
            </p>
          ) : null}
        </div>
      ) : null}

      {isBmwVinForEtk(vehicle) && t.partsCatalogLinkEtk ? (
        <div
          className={
            vehicle.source_url
              ? "mt-6 pt-4 border-t border-[#eef0f4]"
              : "mt-6"
          }
        >
          <p className="text-sm">
            <a
              href={buildBavautoEtkUrl(vehicle.vin_full, vehicle.vin_last7)}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#0b378c] underline break-all"
            >
              {t.partsCatalogLinkEtk}
            </a>
          </p>
        </div>
      ) : null}
    </section>
  );
}
